import $http from './http'
import config from './config'

export default {
    name: 'tourpolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    // getPolicyList(data) {
    //     return $http.post(this.getUrl(`/TourPolicy/List`), data);
    // },
    // labelinfo(LevelID) {
    //     return $http.get(this.getUrl(`/LableInfo/LabelInfo?LevelID=${LevelID}`));
    // },
    // getPolicyDetail(id) {
    //     return $http.get(this.getUrl(`/TourPolicy/Details/${id}`));
    // },
    // SavePolicyDetail(data) {
    //     return $http.post(this.getUrl(`/TourPolicy/Save`), data);
    // },
    // getTravleInfo(id) {
    //     return $http.post(this.getUrl(`/TravleAllDays/GetInfo/${id}`));
    // },
    // saveTravle(data) {
    //     return $http.post(this.getUrl('/TravleAllDays/SaveTravleModel'), data);
    // },
    // getTeamInfos(data) {
    //     return $http.post(this.getUrl(`/PolicySearch/GetTeamInfos`), data);
    // },
    // SaveTeamInfos(data) {
    //     return $http.post(this.getUrl(`/TeamInfo/Save`), data);
    // },
    // getProductFeature() {
    //     return $http.get(this.getUrl(`/PolicySearch/GetProductFeature`));
    // },
    // getimglist() {
    //     return $http.post(this.getUrl('/PolicySearch/GetIndexImg'));
    // },
    // labelInfolist(data) {
    //     return $http.post(this.getUrl(`/PolicySearch/List`), data);
    // },
    // getProducthot() {
    //     return $http.post(this.getUrl('/PolicySearch/GetHotSale'));
    // },
    // saveTourDetail(data) {
    //     return $http.post(this.getUrl('/TourPolicy/SaveTourDetail'), data);
    // },
    // getPosition() {
    //     return $http.post(this.getUrl('/PolicySearch/Position'));
    // },
    // policysearch(data) {
    //     return $http.post(this.getUrl('/PolicySearch/Search'), data); //查询结果
    // },
    // getTop(id) {
    //     return $http.post(this.getUrl(`/PolicySearch/getTop/${id}`));
    // },
    // TouristSpots(id) {
    //     return $http.get(this.getUrl(`/PolicySearch/TouristSpots/${id}`));
    // },
    // TouristSpotsZone(id) {
    //     return $http.post(this.getUrl(`/PolicySearch/TouristSpotsZone/${id}`));
    // },
    // getProductDet(data) {
    //     return $http.post(this.getUrl(`/PolicySearch/Details`), data)
    // },
    // GetInfoList(id) {
    //     return $http.get(this.getUrl(`/TravleAllDays/Trip/${id}`));
    // },
    // getTeamInfoprices(data) {
    //     return $http.post(this.getUrl('/PolicySearch/PolicyTeamPrice'), data);
    // },
    // checkpub() {
    //     // return $http.get(this.getUrl('/TourPolicy/CheckPublish'));
    // },
    // savetradesetting(data) {
    //     // return $http.post(this.getUrl('/TradeSetting/SaveTradeSetting'), data);
    // },
    // getinideximglist(id) {
    //     return $http.get(this.getUrl(`/TourIndexImg/Imglist/${id}`));
    // },
    // setIndexImg(data) {
    //     return $http.post(this.getUrl(`/TourIndexImg/Add`), data);
    // },
    // imgdelete(id) {
    //     return $http.get(this.getUrl(`/TourIndexImg/Delete/${id}`));
    // },
    // copyPolicy(id) {
    //     return $http.get(this.getUrl(`/TourPolicy/CopyPolicy/${id}`));
    // },
    // updatePolicy(data) {
    //     return $http.post(this.getUrl('/TourPolicy/UpdateState'), data);
    // },
    CreatePolicy(data) {
        return $http.post(this.getUrl('/policyinfo/CreatePolicy'), data)
    },

    getProductinfoSave(data) {
        return $http.post(this.getUrl('/productinfo/save'), data)
    },
    getProductinfoDetails(id) {
        return $http.get(this.getUrl(`/productinfo/Details?id=${id}`));
    },
    getThrowinfoList(data) {
        return $http.post(this.getUrl(`/throwinfo/List`), data);
    },
    getThrowinfoSave(data) {
        return $http.post(this.getUrl(`/throwinfo/save`), data);
    },
    getThrowinfoDetails(id) {
        return $http.post(this.getUrl(`/throwinfo/details?id=${id}`));
    },
    getProductinfoList(data) {
        return $http.post(this.getUrl('/productinfo/list'), data)
    },
    getProductinfoSave(data) {
        return $http.post(this.getUrl('/productinfo/save'), data)
    },
    getSpecInfoList(data) {
        return $http.post(this.getUrl('/specInfo/list'), data)
    },
    getSpecInfoSave(data) {
        return $http.post(this.getUrl('/specInfo/save'), data)
    },
    getSpecInfoDetails(id) {
        return $http.post(this.getUrl(`/specInfo/details?id=${id}`))
    },
}



// WEBPACK FOOTER //
// ./src/apis/tourPolicyApi.js